import React from "react";
import { Typography, Button, Row, Col, Form, message } from "antd";
import LogoImg from "../../../assets/images/smallLogo.png";
import BannerImg from "../../../assets/images/banner.png";
import InputBox from "../../../components/common/input";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router";

const { Title, Text } = Typography;

const ResetPassword = () => {
  const [form] = Form.useForm();
  // const { forgetData } = useSelector((state) => state.auth);
  const forgetData =  localStorage.getItem("verifyToken")
  const navigate = useNavigate()

  const handleResetPassword = async (values) => {

    const new_password = values?.newPassword

    const headers = {
      Authorization: `Bearer ${forgetData}`, // Ensure forgetData contains a valid token
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_API_KEY,
    };

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URI}/admin/auth/password/reset`, // Ensure the correct base URL
        { new_password },  // Request body
        { headers } // Headers
      );
  
    
  
      if (response?.status === 201) {
       
        navigate('/')
        message.success("OTP Verified Successfully");
      } else {
        message.error(response?.data?.message || "reset password verification failed");
      }
    } catch (error) {
     
      console.error("Error verifying OTP:", error);
      
    }
  


   
    message.success("Password reset successfully!");
    // Call API for password reset if needed
  };

  return (
    <div className="signinContainer">
      <Row gutter={16} className="signin-row">
        <Col xs={24} sm={12}>
          <div className="leftSection cflex">
            <div className="leftContainer">
              <img src={LogoImg} alt="Logo" className="logo" />
              <Title level={2}>Reset Password</Title>
              <Text className="subtitle mb-2">
                Almost done. Enter your new password and you’re all set.
              </Text>

              {/* Ant Design Form for Validation */}
              <Form
                form={form}
                layout="vertical"
                 requiredMark="optional"
                onFinish={handleResetPassword}
                className="signin-form"
              >
                {/* New Password */}
                <Form.Item
                style={{ marginBottom: "15px" }}
                label={<span>New Password<span style={{ color: "red" }}>*</span></span>}
                  name="newPassword"
                  
                  rules={[
                    { required: true, message: "Please enter a new password!" },
                  ]}
                  hasFeedback
                >
                  <InputBox
                    size="large"
                    placeholder="New Password"
                    className="custom-input"
                    type="password"
                  />
                </Form.Item>

                {/* Confirm New Password */}
                <Form.Item
                style={{ marginBottom: "15px" }}
                  name="confirmPassword"
                  label={<span>Confirm New Password<span style={{ color: "red" }}>*</span></span>}
                  dependencies={["newPassword"]}
                  rules={[
                    { required: true, message: "Please confirm your new password!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Passwords do not match!"));
                      },
                    }),
                  ]}
                  hasFeedback
                >
                  <InputBox
                    size="large"
                    placeholder="Confirm New Password"
                    className="custom-input"
                    type="password"
                  />
                </Form.Item>

                {/* Submit Button */}
                <Form.Item>
                  <Button type="primary" htmlType="submit" className="customButton mt-3">
                    Reset Password
                  </Button>
                </Form.Item>

                <Text className="subtitle mt-5 text-center">© Cultivate 2025</Text>
              </Form>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="rightSection cflex">
            <img src={BannerImg} alt="Banner" className="banner" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ResetPassword;

